// ────────────────────────────────────────────────────────────────────────────
//  cacheReset.ts — zentraler Reset aller user-bezogenen Caches
//
//  WICHTIG: muss bei JEDEM Auth-Wechsel aufgerufen werden
//   - Logout
//   - Login mit anderem Account (auch wenn der vorige nicht explizit ausgeloggt
//     wurde — z.B. Token wurde im Hintergrund überschrieben)
//   - Cross-Tab-Token-Mutation (storage-event)
//
//  Wenn das nicht passiert, sieht der neue User die Daten des alten Users
//  weiter (weil unsere Hooks module-weite Caches halten — das war
//  ursprünglich für Performance gedacht aber führt zu falschem User-Bezug).
// ────────────────────────────────────────────────────────────────────────────

import { resetExtensionsCache, resetProductsCache } from './useExtensions'
import { resetOrgCache }                            from './useOrg'

/// Räumt alle modul-weiten Caches die User-bezogen sind.
/// Aufrufen bei Login (mit anderem User) und bei Logout.
export function resetAllUserCaches() {
  resetExtensionsCache()
  resetProductsCache()
  resetOrgCache()
}
